// src/registeredComponents.ts

import { defineComponents } from '@contentful/experiences-sdk-react';
import { animationVariables, defineAttributes, getVariablesFor } from './definationVariables';
import DynamicFormWrapper from '@/components/DynamicForm/Wrapper';
import CustomLink from '@/components/CustomLink';
import InputField from '@/components/InputField';
import IframeWrapper from '@/components/IframeWrapper';
import Media from '@/components/Media';
import Overlay from '@/components/Overlay';
import { ColumnTextImage } from '@/blocks/Editorials/ColumnTextImage/ColumnTextImage';
import { VideoCard } from '@/blocks/Cards/VideoCard/VideoCard';
import EditorialSlider from '@/blocks/Sliders/EditorialSlider';
import ImageCard from '@/blocks/Cards/ImageCard/ImageCard';
import ImageCard2 from '@/blocks/Cards/ImageCard/ImageCard2';
import LandingWrapper from '@/blocks/Landing/LandingWrapper';
import LandingImageWrapper from '@/blocks/Landing/LandingImageWrapper';
import { QuoteCard } from '@/blocks/Cards/QuoteCard/QuoteCard';
import ImageCardOverlay from '@/blocks/Overlay/ImageCardOverlay/ImageCardOverlay';
import CarouselWrapper from '@/blocks/Sliders/CarouselWrapper';
import ScrollableContainer from '@/blocks/Sliders/ScrollableContainer';
import { ButtonWrapper } from '@/components/ButtonWrapper';
import SectionAnchorId from '@/components/SectionAnchorId/SectionAnchorId';
import { Body, Display, Heading } from '@/client/foundations/Typography';
import IconWrapper from '@/components/Icons/IconWrapper';
import MarqueeWrapper from '@/components/MarqueeWrapper/MarqueeWrapper';
import Footer from '@/components/Footer';
import { ContactUsFormInline } from '@/blocks/ContactUsForm/ContactUsFormInline';
import ModalContainer from '@/components/ModalContainer';
import Container from '@/layouts/Container';
import { StickyContainer } from '@/components/StickyContainer';
import TopMenu from '@/blocks/Navigation/TopMenu';
import InteractiveImage from '@/components/InteractiveImage';
import FloatingContainer from '@/components/FloatingContainer';
import Counter from '@/components/Counter';
import ThemeSelector from '@/components/ThemeSelector';
import StickyElement from '@/components/StickyElement';
import InputDropdown from '@/components/InputDropdown';
import Accordion from '@/components/Accordion';
import ProductFeed from '@/components/ProductFeed';
import FileUpload from '@/components/FileUpload';
import ColorPalette from '@/components/ColorPalette';
import GeneralListingComp from '@/components/GeneralListingComp';
import InstagramEmbed from '@/components/InstagramEmbed';
import ImageWrapper from '@/components/ImageWrapper';
import EmbeddedContainer from '@/blocks/EmbeddedContainer';
import Stepper from '@/components/Stepper';
import NextStep from '@/components/Stepper/NextStep';
import PrevStep from '@/components/Stepper/PrevStep';
import BookingConfirmationPanel from '@/components/BookingConfirmationPanel';
import ProductCard from '@/components/ProductCard';
import EventContainer from '@/components/EventContainer';

defineComponents([
  {
    component: TopMenu,
    definition: {
      id: 'topNav',
      name: 'Baseplate|Top Nav',
      category: 'Components',
      thumbnailUrl: '',
      // children: true,
      slots: {
        topMenuContainer: {
          displayName: 'Top meun container',
        },
        expandedMenu: {
          displayName: 'Expanded meun container',
        },
        bottomStickyCTAs: {
          displayName: 'Sticky CTA buttons',
          
          // allowChildren: true,
          // defaultChildren: []
        }
      },
      variables: {
        ...getVariablesFor('topNav'),
        ...defineAttributes({
          backgroundColor: "#FFFFFF",
          border: '1px solid transparent',
        })
      },
    },
    options: {
      wrapComponent: false,
      wrapContainerWidth: '100%'
    }
  },
  {
    component: DynamicFormWrapper,
    definition: {
      id: 'form',
      name: 'Form',
      category: 'Form Components',
      thumbnailUrl: '',
      // children: true,
      slots: {
        formContent: {
          displayName: 'Form elements',
        },
        successContent: {
          displayName: 'Form Success elements',
        }
      },
      variables: {
        ...getVariablesFor('form'),
        ...defineAttributes({
          backgroundColor: '#FFFFFF',
          border: '1px solid #333333',
          minHeight: '300px',
          width: '300px',
          height: '300px'
        }),
      },
    },
    options: {
      wrapComponent: true,
      // wrapContainerMinWidth: '100px',
      // wrapContainerWidth: 'auto'
    }
  },
  {
    component: CustomLink,
    definition: {
      id: 'link',
      name: 'Link',
      category: 'Custom Components',
      thumbnailUrl: '',
      // children: true,
      slots: {
        linkContent: {
          displayName: "Link content"
        }
      },
      variables: {
        ...getVariablesFor('link'),
        ...defineAttributes({
          backgroundColor: "#FFFFFF00",
          textColor: 'var(--bp-colors-interactive-link)',
          padding: "12px 10px",
          width:"auto",
          margin: "1px",
          fontWeight: "900",
          // width: '150px',
          // height: '40px'
        })
      },
    },
    options: {
      wrapComponent: false,
      // wrapContainerMinWidth: '100px',
      // wrapContainerWidth: 'auto'
    }
  },
  {
    component: InputField,
    definition: {
      id: 'inputField',
      name: 'Input | Text/Textarea/Password',
      category: 'Form Components',
      thumbnailUrl: '',
      children: true,
      variables: {
        ...getVariablesFor('commanInputParams'),
        ...getVariablesFor('inputField'),
        ...defineAttributes({
          backgroundColor: '#FFFFFF00',
          width: '100%',
          height: 'auto',
          margin: '0 0 12px 0',
          // minHeight: '20px',
          // minWidth: '75px',
        }),
      },
    },
    options: {
      wrapComponent: true
    }
  },
  {
    component: InputField,
    definition: {
      id: 'inputHiddenField',
      name: 'Input | Hidden',
      category: 'Form Components',
      thumbnailUrl: '',
      variables: {
        ...getVariablesFor('hiddenField'),
      },
    },
    options: {
      wrapComponent: false
    }
  },
  {
    component: InputField,
    definition: {
      id: 'emailInputField',
      name: 'Input | Email',
      category: 'Form Components',
      thumbnailUrl: '',
      children: true,
      variables: {
        ...getVariablesFor('commanInputParams'),
        ...getVariablesFor('emailInputField'),
        ...defineAttributes({
          backgroundColor: '#FFFFFF00',
          width: '100%',
          height: 'auto',
          margin: '0 0 12px 0',
          // minHeight: '20px',
          // minWidth: '75px',
        }),
      },
    },
    options: {
      wrapComponent: true
    }
  },
  {
    component: InputField,
    definition: {
      id: 'phoneInputField',
      name: 'Input | Phone no.',
      category: 'Form Components',
      thumbnailUrl: '',
      children: true,
      variables: {
        ...getVariablesFor('commanInputParams'),
        ...getVariablesFor('phoneInputField'),
        ...defineAttributes({
          backgroundColor: '#FFFFFF00',
          width: '100%',
          height: 'auto',
          margin: '0 0 12px 0',
          // minHeight: '20px',
          // minWidth: '75px',
        }),
      },
    },
    options: {
      wrapComponent: true
    }
  },
  {
    component: InputField,
    definition: {
      id: 'numberInputField',
      name: 'Input | Number',
      category: 'Form Components',
      thumbnailUrl: '',
      children: true,
      variables: {
        ...getVariablesFor('commanInputParams'),
        ...getVariablesFor('numberInputField'),
        ...defineAttributes({
          backgroundColor: '#FFFFFF00',
          width: '100%',
          height: 'auto',
          margin: '0 0 12px 0',
          // minHeight: '20px',
          // minWidth: '75px',
        }),
      },
    },
    options: {
      wrapComponent: true
    }
  },
  {
    component: InputField,
    definition: {
      id: 'checkboxInputField',
      name: 'Input | Checkbox',
      category: 'Form Components',
      thumbnailUrl: '',
      children: true,
      variables: {
        ...getVariablesFor('commanInputParams'),
        ...getVariablesFor('checkboxInputField'),
        ...defineAttributes({
          backgroundColor: '#FFFFFF00',
          width: '100%',
          height: 'auto',
          margin: '0 0 12px 0',
          // minHeight: '20px',
          // minWidth: '75px',
        }),
      },
    },
    options: {
      wrapComponent: true
    }
  },
   {
    component: InputField,
    definition: {
      id: 'radioButtonInputField',
      name: 'Input | Radio Button',
      category: 'Form Components',
      thumbnailUrl: '',
      children: true,
      variables: {
        ...getVariablesFor('commanInputParams'),
        ...getVariablesFor('radioButtonInputField'),
        ...defineAttributes({
          backgroundColor: '#FFFFFF00',
          width: '100%',
          height: 'auto',
          margin: '0 0 12px 0',
          // minHeight: '20px',
          // minWidth: '75px',
        }),
      },
    },
    options: {
      wrapComponent: true
    }
  },
  {
    component: InputDropdown,
    definition: {
      id: 'inputDropdown',
      name: 'Input | Dropdown',
      category: 'Form Components',
      thumbnailUrl: '',
      children: true,
      variables: {
        ...getVariablesFor('commanInputParams'),
        ...getVariablesFor('inputDropdown'),
        ...defineAttributes({
          backgroundColor: '#FFFFFF00',
          width: '100%',
          height: 'auto',
          margin: '0 0 12px 0',
          // minHeight: '20px',
          // minWidth: '75px',
        }),
      },
    },
    options: {
      wrapComponent: true
    }
  },
  {
    component: InputDropdown,
    definition: {
      id: 'inputBasicDropdown',
      name: 'Input | Basic dropdown',
      category: 'Form Components',
      thumbnailUrl: '',
      children: true,
      variables: {
        ...getVariablesFor('commanInputParams'),
        ...getVariablesFor('inputBasicDropdown'),
        ...defineAttributes({
          backgroundColor: '#FFFFFF00',
          width: '100%',
          height: 'auto',
          margin: '0 0 12px 0',
          // minHeight: '20px',
          // minWidth: '75px',
        }),
      },
    },
    options: {
      wrapComponent: true
    }
  },
  {
    component: FileUpload,
    definition: {
      id: 'fileUpload',
      name: 'File Upload',
      category: 'Custom Components',
      thumbnailUrl: '',
      // children: true,
      variables: {
        ...getVariablesFor('fileUpload'),
        ...defineAttributes({
          backgroundColor: '#FFFFFF00',
          width: '100%',
          height: 'auto',
          margin: '0 0 12px 0',
        }),
      },
    },
  },
  {
    component: ColorPalette,
    definition: {
      id: 'colorPalette',
      name: 'Color Palette',
      category: 'Custom Components',
      thumbnailUrl: '',
      // children: true,
      variables: {
        ...getVariablesFor('colorPalette'),
        ...defineAttributes({
          width: '100%',
          height: 'auto',
        }),
      },
    },
  },
  {
    component: IframeWrapper,
    definition: {
      id: 'iframeWrapper',
      name: 'Iframe',
      category: 'External Embeds',
      thumbnailUrl: '',
      children: false,
      variables: {
        ...getVariablesFor('iframeWrapper'),
        ...defineAttributes({
          height: '100px',
          width: '100px',
          borderRadius: "0px"
        }),
      },
    },
    options: {
      wrapComponent: false
    }
  },
  {
    component: InstagramEmbed,
    definition: {
      id: 'instagramEmbed',
      name: 'Instagram feed',
      category: 'External Embeds',
      thumbnailUrl: '',
      children: false,
      variables: {
        ...getVariablesFor('instagramEmbed'),
        ...defineAttributes({
          height: '500px',
          width: '300px',
        }),
      },
    },
  },
  {
    component: ImageWrapper,
    definition: {
      id: 'baseplateImage',
      name: 'Image',
      children: true,
      category: 'Custom Components',
      thumbnailUrl: '',
      tooltip: {
        description: 'Add images.',
      },
      variables: {
        ...getVariablesFor('image'),
        ...defineAttributes({
          borderRadius: "0px",
          backgroundColor: '#FFFFFF00',
          margin: '0 0 12px 0',
        }),
      },
    },
    options: {
      wrapComponent: false
    }
  },
  {
    component: InteractiveImage,
    definition: {
      id: 'interactiveImage',
      name: 'Baseplate|Interactive Image',
      children: true,
      category: 'Custom Components',
      thumbnailUrl: '',
      tooltip: {
        description: 'Add images with clickable areas.',
      },
      variables: {
        ...getVariablesFor('interactiveImage'),
        // ...defineAttributes({
        //   height: '300px',
        //   width: '300px',
        // }),
      },
    },
  },
  {
    component: Media,
    definition: {
      id: 'media',
      name: 'Baseplate|Media',
      category: 'Custom Components',
      thumbnailUrl: '',
      variables: {
        ...getVariablesFor('media'),
        ...defineAttributes({
          height: '100px',
          width: '100px',
        }),
      },
    },
  },
  {
    component: Overlay,
    definition: {
      id: 'overlay',
      name: 'Baseplate|Overlay',
      category: 'Custom Components',
      thumbnailUrl: '',
      // children: true,
      slots: {
        children: {
          displayName: 'Overlay',
        }
      },
      variables: {
        ...getVariablesFor("overlay"),
        // ...defineAttributes({
        //   backgroundColor: "#ffffff",
        //   // opacity: '0.5'
        // })
      }
    }
  },
  {
    component: Container,
    definition: {
      id: 'baseplateContainer',
      name: 'Baseplate|Container',
      category: 'Custom Components',
      thumbnailUrl: '',
      children: true,
      // slots: {
      //   children: {
      //     displayName: 'Overlay',
      //   }
      // },
      variables: {
        ...getVariablesFor("container"),
        ...defineAttributes({
          borderRadius: "0px",
          height: "100px",
          width: "fit-content",
          flexDirection: "row",
          flexWrap: "wrap",
          border: 0,
          gap: 0,
          // visibility: true
        }),
        // cfHeight: {
        //   displayName: 'Height',
        //   type: 'Text',
        //   group: 'style',
        //   defaultValue: '100%'
        // },
        // title: {
        //   displayName: 'Title',
        //   type: 'Text',
        // },
        // description: {
        //   displayName: 'Description',
        //   type: 'Text',
        // },
        // autoplay: {
        //   displayName: 'Autoplay',
        //   type: 'Boolean',
        //   defaultValue: false,
        //   group: 'style'
        // },
        ...animationVariables
      },
      builtInStyles: [
        'cfPadding', 
        'cfMargin', 
        'cfMaxWidth', 
        'cfBackgroundColor', 
        'cfHorizontalAlignment', 
        'cfVerticalAlignment'
      ]
    },
    options: {
      wrapComponent: false
    }
  },
  {
    component: Accordion,
    definition: {
      id: 'accordion',
      name: 'Accordion',
      category: 'Custom Components',
      // tooltip:{
      //   description:"Accordion with text heading and arbitary body container"
      // },
      slots: {
        headingContainer: {
          displayName: 'Heading Container',
        },
        expandedBody: {
          displayName: 'Expanded Body',
        },
      },
      variables: {
        ...getVariablesFor("accordion"),
        ...defineAttributes({
          width: "100%",
          height: "100%"
        }),
        // cfHeight: {
        //   displayName: 'Height',
        //   type: 'Text',
        //   group: 'style',
        //   defaultValue: '100%'
        // },
        // title: {
        //   displayName: 'Title',
        //   type: 'Text',
        // },
        // description: {
        //   displayName: 'Description',
        //   type: 'Text',
        // },
        // autoplay: {
        //   displayName: 'Autoplay',
        //   type: 'Boolean',
        //   defaultValue: false,
        //   group: 'style'
        // },
        ...animationVariables
      },
      builtInStyles: ['cfMargin', 'cfPadding']
    },
    options: {
      wrapComponent: true
    }
  },
  {
    component: StickyContainer,
    definition: {
      id: 'stickyContainer',
      name: 'Sticky Container',
      category: 'Custom Components',
      thumbnailUrl: '',
      children: true,
      variables: {
        ...getVariablesFor("stickyContainer"),
        ...animationVariables
      },
    },
    options: {
      wrapComponent: false,
      wrapContainerWidth: '100%'
    }
  },
  {
    component: FloatingContainer,
    definition: {
      id: 'floatingContainer',
      name: 'Floating Container',
      category: 'Components',
      thumbnailUrl: '',
      // children: true,
      slots: {
        fixedContent: {
          displayName: 'Fixed Content',
        },
        content: {
          displayName: 'Content',
        }
      },
      builtInStyles: [
        //Make sure these styles are added
        'cfWidth',
        'cfHeight',
      ],
      variables: {
        ...getVariablesFor("floatingContainer"),
        // ...defineAttributes({
        //   flexDirection: "row",
        //   gap: "0px",
        //   width: "100%",
        //   height: "100%"
        // }),
        ...animationVariables
      },
    },
    options: {
      wrapComponent: false,
      wrapContainerWidth: '100%'
    }
  },
  // {
  //   component: RichTextBox,
  //   definition: {
  //     id: 'richTextBox',
  //     name: 'Baseplate|RichTextBox',
  //     category: 'Custom Components',
  //     thumbnailUrl: '',
  //     variables: {
  //       ...getVariablesFor("richTextBox")
  //     }
  //   }
  // },
  {
    component: ColumnTextImage,
    definition: {
      id: 'columntTextImage',
      name: 'Columnt Text Image',
      category: 'Components',
      thumbnailUrl: 'https://tailwindcss.com/_next/static/media/tailwindcss-mark.3c5441fc7a190fb1800d4a5c7f07ba4b1345a9c8.svg',
      tooltip: {
        description: 'This is pattern for Editorial text and image content',
      },
      variables: {
        ...getVariablesFor('columnTextImage'),
      },
      builtInStyles: [
        //Make sure these styles are added
        'cfWidth',
        'cfHeight',
        'cfMargin',
      ],
    },
    options: {
      wrapComponent: true,
    },
  },
  {
    component: VideoCard,
    definition: {
      id: 'cardVideo',
      name: 'Video Card',
      category: 'Components',
      thumbnailUrl: 'https://tailwindcss.com/_next/static/media/tailwindcss-mark.3c5441fc7a190fb1800d4a5c7f07ba4b1345a9c8.svg',
      tooltip: {
        description: 'This is custom Video Card component',
      },
      variables: {
        ...getVariablesFor('videoCard'),
        // ...defineAttributes({
        //   horizontalAlignment: 'left', //start' | 'end' | 'center';
        //   verticalAlignment: 'center', //'start' | 'end' | 'center';
        // }),
        ...animationVariables,
      },
      children: true,
      slots: {
        mediaOverlay: {
          displayName: 'Media overlay',
        }
      },
      builtInStyles: [
        'cfMargin',
        // 'cfHorizontalAlignment',
        // 'cfVerticalAlignment',
      ]
    },
  },
  {
    component: EditorialSlider,
    definition: {
      id: 'editorialSlider',
      name: 'Editorial with slider',
      category: 'Components',
      thumbnailUrl: 'https://tailwindcss.com/_next/static/media/tailwindcss-mark.3c5441fc7a190fb1800d4a5c7f07ba4b1345a9c8.svg',
      tooltip: {
        description: 'This is custom Editorial with slider component',
      },
      children: true,
      variables: {
        ...getVariablesFor('editorialSlider'),
      },
    },
  },
  {
    component: ImageCard,
    definition: {
      id: 'cardImage',
      name: 'Image Card',
      category: 'Components',
      thumbnailUrl: 'https://tailwindcss.com/_next/static/media/tailwindcss-mark.3c5441fc7a190fb1800d4a5c7f07ba4b1345a9c8.svg',
      tooltip: {
        description: 'This is custom Image Card component',
      },
      children: true,
      slots: {
        mediaOverlay: {
          displayName: 'Media overlay',
        }
      },
      variables: {
        ...getVariablesFor('cardImage'),
        ...getVariablesFor('imageCartOptionalParams'),
        ...animationVariables,
        ...defineAttributes({
          maxWidth: '100%',
          textColor: 'var(--bp-colors-typography-body)'
        }),
        // ...defineAttributes({
        //   horizontalAlignment: 'left', //start' | 'end' | 'center';
        //   verticalAlignment: 'center', //'start' | 'end' | 'center';
        // }),
        // ...defineAttributes({
        // backgroundColor: "#F7F4EF",
        // borderRadius: "40px",
        // padding: "40px 40px 40px 40px"
        // }),
      },
      builtInStyles: [
        // 'cfHorizontalAlignment',
        // 'cfVerticalAlignment',
        'cfWidth',
        'cfMargin',
      ]
    },
  },
  {
    component: ImageCard2,
    definition: {
      id: 'droppableAreaCardImage',
      name: 'Adaptive Image Card',
      category: 'Components',
      thumbnailUrl: 'https://tailwindcss.com/_next/static/media/tailwindcss-mark.3c5441fc7a190fb1800d4a5c7f07ba4b1345a9c8.svg',
      tooltip: {
        description: 'This is custom Image Card component',
      },
      // children: true,
      slots: {
        mediaOverlay: {
          displayName: 'Media overlay',
        },
        childrenContent: {
          displayName: "Optional content"
        }
      },
      variables: {
        ...getVariablesFor('cardImage'),
        ...animationVariables,
        ...defineAttributes({
          maxWidth: '100%',
          width: 'auto',
          padding: 0,
          margin: 0,
          backgroundColor: '#FFFFFF00',
          borderRadius: 0
        })
      },
      // builtInStyles: [
      //   // 'cfHorizontalAlignment',
      //   // 'cfVerticalAlignment',
      //   'cfWidth',
      //   'cfMargin',
      // ]
    },
    options: {
      wrapComponent: false
    },
  },
  {
    component: ImageCardOverlay,
    definition: {
      id: 'cardImageOverlay',
      name: 'Image Card Overlay',
      category: 'Components',
      thumbnailUrl: 'https://tailwindcss.com/_next/static/media/tailwindcss-mark.3c5441fc7a190fb1800d4a5c7f07ba4b1345a9c8.svg',
      tooltip: {
        description: 'This is custom Image Card component with overlay slider',
      },
      children: true,
      variables: {
        ...getVariablesFor('cardImageOverlay'),
        ...animationVariables,
      },
    },
  },
  {
    component: LandingWrapper,
    definition: {
      id: 'landing',
      name: 'Landing Video',
      category: 'Components',
      thumbnailUrl: 'https://tailwindcss.com/_next/static/media/tailwindcss-mark.3c5441fc7a190fb1800d4a5c7f07ba4b1345a9c8.svg',
      tooltip: {
        description: 'This is a prescriptive video hero made up of designs system elements.',
      },
      variables: {
        ...getVariablesFor('landing'),
        ...animationVariables,
      },
      builtInStyles: [
        //Make sure these styles are added
        'cfWidth',
        'cfHeight',
        'cfMargin',
      ],
    },
    options: {
      wrapComponent: true,
    },
  },
  {
    component: LandingImageWrapper,
    definition: {
      id: 'landingImage',
      name: 'Landing Image',
      category: 'Components',
      thumbnailUrl: 'https://tailwindcss.com/_next/static/media/tailwindcss-mark.3c5441fc7a190fb1800d4a5c7f07ba4b1345a9c8.svg',
      tooltip: {
        description: 'This is a prescriptive image hero made up of designs system elements.',
      },
      variables: {
        ...getVariablesFor('landingImage'),
      },
    },
    options: {
      wrapComponent: false,
    },
  },
  {
    component: QuoteCard,
    definition: {
      id: 'quoteVideo',
      name: 'Quote Card',
      category: 'Components',
      thumbnailUrl: 'https://tailwindcss.com/_next/static/media/tailwindcss-mark.3c5441fc7a190fb1800d4a5c7f07ba4b1345a9c8.svg',
      tooltip: {
        description: 'This is custom Quote Card component',
      },
      variables: {
        ...getVariablesFor('quoteVideo'),
        ...animationVariables,
      },
    },
    options: {
      wrapComponent: false,
    },
  },
  {
    component: CarouselWrapper,
    definition: {
      id: 'carouselContainer',
      name: 'Carousel container',
      category: 'Sliders',
      thumbnailUrl: 'https://tailwindcss.com/_next/static/media/tailwindcss-mark.3c5441fc7a190fb1800d4a5c7f07ba4b1345a9c8.svg',
      tooltip: {
        description: 'This is pattern for carousel container component',
      },
      children: true,
      variables: {
        ...getVariablesFor('carouselContainer'),
        ...defineAttributes({
          width: '100%',
        }),
      },
    },
    options: {
      wrapComponent: false,
    },
  },
  {
    component: ScrollableContainer,
    definition: {
      id: 'scrollableContainer',
      name: 'Scrollable Container',
      category: 'Sliders',
      thumbnailUrl: 'https://tailwindcss.com/_next/static/media/tailwindcss-mark.3c5441fc7a190fb1800d4a5c7f07ba4b1345a9c8.svg',
      tooltip: {
        description: 'Scrollable container',
      },
      children: true,
      variables: {
        ...getVariablesFor('scrollableContainer'),
        ...animationVariables,
      },
    },
    options: {
      wrapComponent: false,
    },
  },
  {
    component: ButtonWrapper, // Used in Circuit
    definition: {
      id: 'button',
      name: 'Button',
      category: 'Elements',
      thumbnailUrl: 'https://tailwindcss.com/_next/static/media/tailwindcss-mark.3c5441fc7a190fb1800d4a5c7f07ba4b1345a9c8.svg',
      tooltip: {
        description: 'This is a custom button created for our design system.',
      },
      variables: {
        ...getVariablesFor('buttonProps'),
        ...getVariablesFor('buttonWrapper'),
        ...defineAttributes({
          borderRadius: '40px',
          width: '100px',
          visibility: 'visible',
        }),
        // ...defineAttributes({
        //   borderRadius: '0px',
        // }),
      },
    },
    options: {
      wrapComponent: true,
    },
  },
  {
    component: ButtonWrapper, // Used in Circuit
    definition: {
      id: 'link2',
      name: 'Link2',
      category: 'Elements',
      thumbnailUrl: 'https://tailwindcss.com/_next/static/media/tailwindcss-mark.3c5441fc7a190fb1800d4a5c7f07ba4b1345a9c8.svg',
      tooltip: {
        description: 'This is a custom link created for our design system.',
      },
      variables: {
        ...getVariablesFor('buttonProps'),
        ...getVariablesFor('buttonWrapper'),
        ...getVariablesFor('link2'),
        ...defineAttributes({
          borderRadius: '40px',
          width: '100px',
          visibility: 'visible',
        })
      },
    },
    options: {
      wrapComponent: false,
    },
  },
  {
    component: ButtonWrapper,
    definition: {
      id: 'buttonWrapper',
      name: 'Form | Button',
      category: 'Form Components',
      thumbnailUrl: 'https://tailwindcss.com/_next/static/media/tailwindcss-mark.3c5441fc7a190fb1800d4a5c7f07ba4b1345a9c8.svg',
      tooltip: {
        description: 'This is a custom button created for our design system.',
      },
      variables: {
        ...getVariablesFor('buttonProps'),
        ...getVariablesFor('formButton'),
        ...defineAttributes({
          borderRadius: '40px',
          width: '100%',
          border:"0px solid transparent",
          // height: '42px',
          visibility: 'visible',
        }),
      },
      // builtInStyles: ['cfBorder'],
    },
    options: {
      wrapComponent: false,
    },
  },
  {
    component: SectionAnchorId,
    definition: {
      id: 'sectionAnchorId',
      name: 'Section Anchor Id',
      category: 'Elements',
      thumbnailUrl: 'https://tailwindcss.com/_next/static/media/tailwindcss-mark.3c5441fc7a190fb1800d4a5c7f07ba4b1345a9c8.svg',
      tooltip: {
        description: 'This is custom component to manage id based anchored sections',
      },
      variables: {
        ...getVariablesFor('sectionAnchorId'),
      },
    },
  },
  {
    component: Body,
    definition: {
      id: 'body',
      name: 'Body',
      category: 'Elements',
      thumbnailUrl: 'https://tailwindcss.com/_next/static/media/tailwindcss-mark.3c5441fc7a190fb1800d4a5c7f07ba4b1345a9c8.svg',
      tooltip: {
        description: 'This is a custom Body set based on circuit B2B Design.',
      },
      variables: {
        ...getVariablesFor('body'),
        ...defineAttributes({
          textColor: 'var(--bp-colors-typography-body)',
          margin: '0 0 0 0',
          textAlign: 'left',
        }),
        ...animationVariables,
      },
    },
  },
  {
    component: Display,
    definition: {
      id: 'display',
      name: 'Display',
      category: 'Elements',
      thumbnailUrl: 'https://tailwindcss.com/_next/static/media/tailwindcss-mark.3c5441fc7a190fb1800d4a5c7f07ba4b1345a9c8.svg',
      tooltip: {
        description: 'This is a custom Display set based on circuit B2B Design.',
      },
      variables: {
        ...getVariablesFor('display'),
        ...defineAttributes({
          textColor: 'var(--bp-colors-typography-display)',
          margin: '0 0 0 0',
          textAlign: 'left',
        }),
        ...animationVariables,
      },
    },
  },
  {
    component: Heading,
    definition: {
      id: 'heading',
      name: 'Heading',
      category: 'Elements',
      thumbnailUrl: 'https://tailwindcss.com/_next/static/media/tailwindcss-mark.3c5441fc7a190fb1800d4a5c7f07ba4b1345a9c8.svg',
      tooltip: {
        description: 'This is a custom Heading set based on circuit B2B Design.',
      },
      variables: {
        ...getVariablesFor('heading'),
        ...defineAttributes({
          textColor: 'var(--bp-colors-typography-heading)',
          margin: '0 0 0 0',
          textAlign: 'left',
        }),
        ...animationVariables,
      },
    }
  },
  {
    component: IconWrapper,
    definition: {
      id: 'icons',
      name: 'Icon',
      category: 'Elements',
      thumbnailUrl: 'https://tailwindcss.com/_next/static/media/tailwindcss-mark.3c5441fc7a190fb1800d4a5c7f07ba4b1345a9c8.svg',
      tooltip: {
        description: 'This is a custom icon set based on circuit B2B Design.',
      },
      variables: {
        ...getVariablesFor('icons'),
      },
    },
  },
  {
    component: MarqueeWrapper,
    definition: {
      id: 'marquee',
      name: 'Marquee',
      category: 'Elements',
      thumbnailUrl: 'https://tailwindcss.com/_next/static/media/tailwindcss-mark.3c5441fc7a190fb1800d4a5c7f07ba4b1345a9c8.svg',
      tooltip: {
        description: 'This is a custom Marquee based on circuit B2B Design.',
      },
      variables: {
        ...getVariablesFor('marquee'),
      },
    },
  },
  {
    component: ModalContainer,
    definition: {
      id: 'modalContainer',
      name: 'Modal container',
      category: 'Components',
      // This is the thumbnail that will be shown in the sidebar
      thumbnailUrl: 'https://tailwindcss.com/_next/static/media/tailwindcss-mark.3c5441fc7a190fb1800d4a5c7f07ba4b1345a9c8.svg',
      // This is the tooltip that will be shown when hovering over the component in the sidebar
      tooltip: {
        description: 'This is component to manage modal container',
        // there is also an option to include an image in the tooltip
      },
      children: true,
      // These are the variables that can be set for the component
      variables: {
        ...getVariablesFor("modalContainer")
      },
    },
    options: {
      wrapComponent: true
    }
  },
  {
    component: Footer,
    definition: {
      id: 'footerContainer',
      name: 'Footer',
      category: 'Components',
      thumbnailUrl: 'https://tailwindcss.com/_next/static/media/tailwindcss-mark.3c5441fc7a190fb1800d4a5c7f07ba4b1345a9c8.svg',
      children: true,
      tooltip: {
        description: 'This is custom footer component',
      },
      variables: {
        ...getVariablesFor('footerContainer'),
      },
      builtInStyles: [
        //Make sure these styles are added
        'cfWidth',
        'cfHeight',
        'cfMargin',
      ],
    },
    options: {
      wrapComponent: true,
    },
  },
  {
    component: Footer,
    definition: {
      id: 'footer',
      name: 'Circuit Footer',
      category: 'Components',
      thumbnailUrl: 'https://tailwindcss.com/_next/static/media/tailwindcss-mark.3c5441fc7a190fb1800d4a5c7f07ba4b1345a9c8.svg',
      children: true,
      tooltip: {
        description: 'This is custom footer component',
      },
      variables: {
        ...getVariablesFor('footerContainer'),
      },
      builtInStyles: [
        //Make sure these styles are added
        'cfWidth',
        'cfHeight',
        'cfMargin',
      ],
    },
    options: {
      wrapComponent: true,
    },
  },
  {
    component: ContactUsFormInline,
    definition: {
      // This id is the same as the "basic" component that default experiences have
      // This is how we override the default button component
      id: 'contactUs',
      name: 'Contact Us Form',
      // This is the category that the component will be placed in the sidebar
      category: 'Components',
      // This is the thumbnail that will be shown in the sidebar
      thumbnailUrl: 'https://tailwindcss.com/_next/static/media/tailwindcss-mark.3c5441fc7a190fb1800d4a5c7f07ba4b1345a9c8.svg',
      // This is the tooltip that will be shown when hovering over the component in the sidebar
      tooltip: {
        description: 'This is custom Contact us form',
        // there is also an option to include an image in the tooltip
      },
      // These are the variables that can be set for the component
      variables: {
        ...getVariablesFor('contactUs'),
      },
    },
    options: {
      wrapComponent: false,
    },
  },
  {
    component: Counter,
    definition: {
      // This id is the same as the "basic" component that default experiences have
      // This is how we override the default button component
      id: 'bp-counter',
      name: 'Counter',
      // This is the category that the component will be placed in the sidebar
      category: 'Components',
      // This is the thumbnail that will be shown in the sidebar
      thumbnailUrl: 'https://tailwindcss.com/_next/static/media/tailwindcss-mark.3c5441fc7a190fb1800d4a5c7f07ba4b1345a9c8.svg',
      // This is the tooltip that will be shown when hovering over the component in the sidebar
      tooltip: {
        description: 'This is custom counter',
        // there is also an option to include an image in the tooltip
      },
      // These are the variables that can be set for the component
      variables: {
        ...getVariablesFor('counter'),
      },
    },
    options: {
      wrapComponent: false,
    },
  },
  {
    component: ThemeSelector,
    definition: {
      id: 'bp-themeSelector',
      name: 'Theme selector',
      // This is the category that the component will be placed in the sidebar
      category: 'Components',
      // This is the thumbnail that will be shown in the sidebar
      thumbnailUrl: 'https://tailwindcss.com/_next/static/media/tailwindcss-mark.3c5441fc7a190fb1800d4a5c7f07ba4b1345a9c8.svg',
      // This is the tooltip that will be shown when hovering over the component in the sidebar
      tooltip: {
        description: 'This is change theme'
        // there is also an option to include an image in the tooltip
      },
      // These are the variables that can be set for the component
      variables: {
        ...getVariablesFor('themeSelector'),
      },
    },
    options: {
      wrapComponent: false,
    },
  },
  {
    component: StickyElement,
    definition: {
      id: 'bp-StickyElement',
      name: 'Sticky Element',
      // This is the category that the component will be placed in the sidebar
      category: 'Components',
      children: true,
      // This is the thumbnail that will be shown in the sidebar
      thumbnailUrl: 'https://tailwindcss.com/_next/static/media/tailwindcss-mark.3c5441fc7a190fb1800d4a5c7f07ba4b1345a9c8.svg',
      // This is the tooltip that will be shown when hovering over the component in the sidebar
      tooltip: {
        description: 'This is sticky element. It will stick with respect to the parent container'
        // there is also an option to include an image in the tooltip
      },
      // These are the variables that can be set for the component
      variables: {
        ...getVariablesFor('stickyElement'),
      },
    },
    options: {
      wrapComponent: false,
    },
  },
  {
    component: GeneralListingComp,
    definition: {
      id: 'generalListingComp',
      name: 'General Listing Component',
      category: 'Custom Components',
      variables: {
        ...getVariablesFor("generalListingComp"),
        ...defineAttributes({
          width: "100%",
          height: "100%"
        }),
        // ...animationVariables
      },
      builtInStyles: ['cfMargin', 'cfPadding']
    },
    options: {
      wrapComponent: true
    }
  },
  {
    component: ProductFeed,
    definition: {
      id: 'productFeed',
      name: 'Product Feed',
      category: 'Custom Components',
      variables: {
        ...getVariablesFor("productFeed"),
        ...defineAttributes({
          width: "100%",
          height: "100%"
        }),
        ...animationVariables
      },
      builtInStyles: ['cfMargin', 'cfPadding']
    },
    options: {
      wrapComponent: true
    }
  },
  {
    component: EmbeddedContainer,
    definition: {
      id: 'embeddedContainer',
      name: 'Embedded Container',
      category: 'Custom Components',
      variables: {
        ...getVariablesFor("embeddedContainer"),
        ...defineAttributes({
          width: "100%",
          height: "100%"
        })
      },
      builtInStyles: ['cfMargin', 'cfPadding']
    },
    options: {
      wrapComponent: true
    }
  },
  {
    component: Stepper,
    definition: {
      id: 'stepper',
      name: 'Steps',
      category: 'Step Components',
      thumbnailUrl: '',
      children: true,
      variables: {
        ...getVariablesFor('stepper')
      },
      builtInStyles: [
        //Make sure these styles are added
        'cfWidth',
        'cfHeight',
      ]
    }
  },
  {
    component: NextStep,
    definition: {
      id: 'nextStep',
      name: 'Next Step',
      category: 'Step Components',
      thumbnailUrl: '',
      children: true,
      variables: {
        ...getVariablesFor('nextStep')
      },
      builtInStyles: [
        //Make sure these styles are added
        'cfWidth',
        'cfHeight',
      ]
    }
  },
  {
    component: PrevStep,
    definition: {
      id: 'prevStep',
      name: 'Previous Step',
      category: 'Step Components',
      thumbnailUrl: '',
      children: true,
      variables: {
        ...getVariablesFor('prevStep')
      },
      builtInStyles: [
        //Make sure these styles are added
        'cfWidth',
        'cfHeight',
      ]
    }
  },
  {
    component: BookingConfirmationPanel,
    definition: {
      id: 'bookingConfirmationPanel',
      name: 'Booking Confirmation Panel',
      category: 'Custom Components',
      variables: {
        ...getVariablesFor("bookingConfirmationPanel"),
        ...defineAttributes({
          width: "100%",
          height: "100%"
        }),
        ...animationVariables
      },
      builtInStyles: ['cfMargin', 'cfPadding']
    },
    options: {
      wrapComponent: true
    }
  },
  {
    component: ProductCard,
    definition: {
      id: 'productCard',
      name: 'Product Card',
      category: 'Custom Components',
      variables: {
        ...getVariablesFor("productCard"),
        ...defineAttributes({
          width: "100%",
          height: "100%"
        }),
      },
      builtInStyles: ['cfMargin', 'cfPadding']
    },
    options: {
      wrapComponent: true
    }
  },
  {
    component: EventContainer,
    definition: {
      id: 'eventContainer',
      name: 'Hide/Show Container',
      category: 'Custom Components',
      children: true,
      variables: {
        ...getVariablesFor("eventContainer"),
        ...defineAttributes({
          width: "100%",
          height: "100%"
        }),
      },
      builtInStyles: ['cfMargin', 'cfPadding']
    },
    options: {
      wrapComponent: true
    }
  }
]);
